import { isEmpty } from 'lodash';

/**
 * wrapperElement: Elemento que dentro contiene los checkboxes
 */
export function gestionarIncompatibles(wrapperElement) {
  wrapperElement.querySelectorAll('[data-incompatibles]').forEach((input) => {
    const { incompatibles } = input.dataset;
    if (isEmpty(incompatibles)) {
      return;
    }

    input.addEventListener('change', () => {
      if (input.checked) {
        wrapperElement.querySelectorAll(incompatibles).forEach((inputIncompatible) => {
          if (inputIncompatible === input) {
            return;
          }
          inputIncompatible.checked = false;
        });
      }
    });
  });
}

export function marcarTodos(wrapperElement, { selectorChecks = 'input[type=checkbox]' } = {}) {
  // Verificar si todos los checkboxes están seleccionados
  const checkboxes = wrapperElement.querySelectorAll(selectorChecks);
  const todosSeleccionados = Array.from(checkboxes).every((checkbox) => checkbox.checked);

  // Si todos están seleccionados, desmarcar todos; si no, marcar todos
  checkboxes.forEach((checkbox) => {
    if (checkbox) {
      if (todosSeleccionados && checkbox.checked) {
        checkbox.click(); // Desmarcar
      } else if (!todosSeleccionados && !checkbox.checked) {
        checkbox.click(); // Marcar
      }
    }
  });
}
